import { Rutas } from '@/constants/rutas';

export const NavigationColaboradoresItems = [
    {
        title: 'Argamboy',
        shortTitle: 'Argamboy',
        path: Rutas.COLABORADOR_ARGAMBOY,
    },
    // {
    //     title: 'Taboo',
    //     shortTitle: 'Taboo',
    //     path: Rutas.COLABORADOR_TABOO,
    // },
];
